import styles from './BigSwitch.module.css';

/**
 * A large switch that says Off or On inside it, for the settings an owner
 * turns on and off (Jason, 10 Oct: the widget and team mode first, then the
 * rest of settings), so which way each is reads at a glance. A native
 * checkbox with the switch role, as the shared Switch is, so Space toggles it
 * and assistive tech hears a switch; the Off and On inside are for the eye.
 *
 * Named by the visible heading beside it (`labelledBy`), or by `label` where
 * the setting's name is said some other way.
 */
export function BigSwitch({ id, checked, onChange, labelledBy, label, disabled }: {
  id?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
} & (
  /** The id of the visible name, such as the setting's heading. */
  | { labelledBy: string; label?: never }
  /** The switch's name, where no element beside it carries it. */
  | { label: string; labelledBy?: never }
)) {
  return (
    <span className={styles.wrap} data-on={checked}>
      <input
        id={id}
        type="checkbox"
        role="switch"
        className={styles.input}
        checked={checked}
        disabled={disabled}
        aria-labelledby={labelledBy}
        aria-label={label}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className={styles.track} aria-hidden>
        <span className={styles.on}>On</span>
        <span className={styles.off}>Off</span>
        <span className={styles.thumb} />
      </span>
    </span>
  );
}
